export default __webpack_public_path__ + "static/media/KO_homeButton.5dc4cdf0.png";